import { BASE_URL } from "../../App";
import DynamicTable from '../Reusable/DynamicTable';
import CustomTextField from "../Reusable/Numerictext";
import CustomButton from "../Reusable/CustomButton";
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import { Row, Col } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { Dialog, DialogTitle, DialogContent,FormGroup, DialogActions,FormControlLabel, TextField, Button, MenuItem,Backdrop, CircularProgress, } from '@mui/material';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Swal from 'sweetalert2';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import ExcelJS from 'exceljs';

export default function UserCreateTable() {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isCreateUserPopupOpen, setCreateUserPopupOpen] = useState(false);
    const [isViewPopupOpen, setViewPopupOpen] = useState(false);
    const [editedRowData, setEditedRowData] = useState(null);
    const [editingRow, setEditingRow] = useState(null);
    const [viewData, setViewData] = useState(null);
    const [FunctionnameList, setFunctionnameList] = useState([]);
    const [YEARDETAILSList, setYEARDETAILSList] = useState([]);
      const [dealerOptions, setDealerOptions] = useState([]);
        const [selectedDealer, setSelectedDealer] = useState(null);
        console.log('view',viewData);

    const fetchData = () => {
        setOpen(true);
        axios.post(BASE_URL + '/solardealermappinglist')
            .then(response => {
                if (response.status === 200) {
                    setTableData(response.data.SolarDealerMappingList);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
                setOpen(false);
            })
            
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    
                } else {
                  
                }
                setOpen(false);
            });
    };


    const DROPDOWNAPI = async () => {
      setOpen(true);
      try {
          const response = await axios.post(BASE_URL + '/getdealercode', { 
              login_id: login_id
          });
          const responseData = response.data;
          const FUNCTION = responseData.DEALER_CODE || [];
          setFunctionnameList(FUNCTION);
      } catch (error) {
          console.error("Error fetching dealer codes:", error);
      } finally {
        setOpen(false);
      }
  };


    

    const Branch_code = localStorage.getItem("BRANCH_CODE");
    const login_id = localStorage.getItem("LOGIN_ID");
    
    useEffect(() => {
        if (!login_id || !Branch_code) {
            Swal.fire({
                icon: "warning",
                text: 'Login Failed !'
            });
            localStorage.clear()
            navigate('/')
           navigate('/Login')
        } else {
            fetchData();
            DROPDOWNAPI();
        }
    }, []);
    // useEffect(() => {
        
    //         fetchData();
    //         DROPDOWNAPI();

    // }, []);

    const openCreateUserPopup = (formattedRowData) => {
        setCreateUserPopupOpen(true);
        setEditedRowData(formattedRowData);
    };

    const handleViewEditClick = (formattedRowData) => {
        setViewData(formattedRowData);
        setViewPopupOpen(true);
    };

    const handleReload = () => {
        //alert(1);
        fetchData();
        
    }


    const handleDownloadExcel = () => {
        if (tableData.length === 0) {
          Swal.fire({
            icon: "info",
            text: 'No Data Available For export!'
          });
          return;
        }
        Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to download the Excel file?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, download it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen(true);
    
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sales Report');
    
            worksheet.columns = Object.keys(tableData[0]).map(key => ({ header: key, key }));
    
            tableData.forEach(data => worksheet.addRow(data));
            
            const headerRow = worksheet.getRow(1);
            headerRow.eachCell((cell) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'ADD8E6' }
              };
            });
    
            worksheet.autoFilter = {
              from: 'A1',
              to: 'D1'
            };
    
            setTimeout(() => {
              workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Solar Project List.xlsx';
                link.click();
                setOpen(false);
              });
            }, 1000);
          }
        });
      };



    return (
        <>


            <DynamicTable data={tableData} onEditClick={openCreateUserPopup} onViewClick={handleViewEditClick} />
            {isCreateUserPopupOpen && (
                <EditUserPopup
                    user={editedRowData}
                    FunctionnameList={FunctionnameList}
                    onClose={() => {
                        setCreateUserPopupOpen(false);
                        setEditedRowData(null);
                    }}
                    onSave={() => handleReload()}
                />
            )}
            {editingRow && (
                <EditUserPopup
                    FunctionnameList={FunctionnameList}
                    user={editingRow.original}
                    onClose={() => setEditingRow(null)}
                    onSave={() => handleReload()}
                />
            )}
            {isViewPopupOpen && (
                <ViewDataPopup
                    data={viewData}
                    onClose={() => setViewPopupOpen(false)}
                />
            )}
             <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
            <CircularProgress color="inherit" />
          </Backdrop>
          <br></br>
          <Button
              variant="contained"
              sx={{
                backgroundColor: 'green',
                '&:hover': { backgroundColor: 'darkgreen' },
              }}
              style={{ width: '250px' }}
              onClick={handleDownloadExcel}
            >
              Download Excel
            </Button>
        </>
    );
}

const EditUserPopup = ({ user, onClose, FunctionnameList, onSave  }) => {
    // const [editedUser, setEditedUser] = useState({
    //     DEALER_CODE: user?.DEALER_CODE , 
    //     DEALERNAME: user?.DEALERNAME ,
    //     ProjectID: user?.ProjectID ,
    //     Active: user?.Active , 
    // });
     const [editedUser, setEditedUser] = useState({ ...user });


    const isCreateMode = !user;




    useEffect(() => {
        if (!user ) {
            setEditedUser(prevState => ({
                ...prevState,
            }));
        }
    }, [user]);


    // const Function_Options = FunctionnameList ? FunctionnameList.map((type) => ({
    //     Value: type.DEALER_CODE,
    //     Label: type.DEALERNAME,
    // })) : [];


    // const Function_Options = FunctionnameList
    // ? FunctionnameList.map((type) => ({
    //       Value: type.DEALER_CODE,
    //       Label: type.DEALERNAME,
    //   }))
    // : [];
    const Function_Options = FunctionnameList.map((type) => ({
      value: type.DEALER_CODE,
      label: type.DEALERNAME,
  }));

  const selectedOption = user
    ? Function_Options.find((opt) => opt.value === editedUser.DealerCode)
    : Function_Options.find((opt) => opt.label === editedUser.DealerName);


    const [inputs, setInputs] = useState({
        DEALER_CODE: '', DEALERNAME: '', ProjectID: '', Active: ''
    });

    // const handleChange = (fieldName) => (event) => {


    //     setEditedUser((prev) => ({ ...prev, [fieldName]: value }));
    //     setInputs({ ...inputs, [event.target.name]: event.target.value });
    //     setEditedUser({
    //         ...editedUser,
    //         [fieldName]: value,
    //     });
    // };
    // const handleChange = (fieldName) => (event) => {
    //     const value = event.target.value;
    
    //     setEditedUser((prev) => ({
    //         ...prev,
    //         [fieldName]: value,
    //     }));
    // };
    const handleChange = (fieldName) => (event) => {

        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setEditedUser((prev) => ({ ...prev, [fieldName]: value }));
        setInputs({ ...inputs, [event.target.name]: event.target.value });
        setEditedUser({
            ...editedUser,
            [fieldName]: value,
        });
    };

    const handleSave = async () => {
        const selectedItem = FunctionnameList.find((deepan) => deepan.DEALER_CODE === editedUser.DEALER_CODE);
 
        if (selectedItem) {
         //    alert(`Selected Item Code: ${editedUser.DEALER_CODE}, Description: ${selectedItem.DEALERNAME}`);
        } else {
            const selectedItem = FunctionnameList.find((deepan) => deepan.DEALER_CODE === editedUser.DEALER_CODE);
          //  alert(editedUser.DEALER_CODE);
          //  alert(editedUser.DEALERNAME);
             //alert ('No item selected!');
             
        }

        const login_id = localStorage.getItem("LOGIN_ID");


       const data = {
    DealerCode: editedUser?.DEALER_CODE || "", // Use optional chaining with fallback
    DealerName: selectedItem?.DEALERNAME || "", // Fallback to an empty string if undefined
    ProjectId: editedUser?.ProjectId || "", // Provide fallback for empty values
    Active: editedUser?.Active ?? 0, // Default to 0 if undefined
    login_id: login_id, // Pass the login_id
};

const update = {
    DealerCode: editedUser?.DealerCode || "", // Consistent fallback handling
    DealerName: editedUser?.DealerName || "", // Ensure a fallback value
    ProjectId: editedUser?.ProjectId || "", // Consistent structure
    Active: editedUser?.Active ?? 0, // Default to 0 if undefined
    login_id: login_id, // Pass the login_id
};
        try {
            let response;
            if (user) {
               
                    response = await axios.post(BASE_URL + '/solardealermappingupdate', update);
                    onSave();
                    onClose();
            
                   
                }
             else {
                response = await axios.post(BASE_URL + '/solarDealerMappingcreate', data);

            }
            Swal.fire({
                icon: 'success',
                text: response.data.text || 'Data saved successfully!',
            }).then(() => {
                onSave();
                onClose();
            });
        } catch (error) {
            if (error.response) {
                
                const errorMessages = error.response.data.message;
                const errorMessageList = errorMessages.map((message, index) => `${index + 1}. ${message}`).join('\n');
                Swal.fire({
                    allowOutsideClick:false,
                    position: 'top-end',
                  icon: 'error',
                  title: 'Error',
                  text: errorMessageList,
                  timer: 3000,
                  showConfirmButton: false,
                  timerProgressBar: true,
                  
                });
                return;
            } else if (error.request) {

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No response received from the server.',
                });
            } else {

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error setting up the request. Please try again.',
                });
            }
        } finally {
            onClose()
            
        }
    }

    const handleProjectIdChange = (e) => {
      setEditedUser({ ...editedUser, ProjectId: e.target.value });
  };
  
   const handleAutocompleteChange = (event, newValue) => {
    if (user) {
      // If `user` exists, update the dealer code
      setEditedUser({ ...editedUser, DealerCode: newValue?.value || '' });
    } else {
      // If `user` doesn't exist, update the dealer name and code
      setEditedUser({
        ...editedUser,
        DealerName: newValue?.label || '',
        DEALER_CODE: newValue?.value || '',
      });
    }
  };
  
    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }} BackdropProps={{ invisible: true }} >
            <DialogTitle><u><b>{user ? 'Solar Project ID Creation' : ' Solar Project ID Creation'}</b></u></DialogTitle>
            <DialogContent>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <div className="col-lg form-group">
                <Autocomplete
    options={Function_Options}
    getOptionLabel={(option) => `${option.value} - ${option.label}`}
    value={selectedOption || null}
    onChange={handleAutocompleteChange}
    filterOptions={(options, state) =>
        options
            .filter((option) =>
                option.label.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                option.value.toLowerCase().includes(state.inputValue.toLowerCase())
            )
    }
    onInputChange={(event, newInputValue) => {
        // You can store newInputValue if you need it for other purposes
    }}
   
    renderInput={(params) => (
        <TextField
            {...params}
            label="Select Dealer"
            variant="outlined"
        />
    )}
/>

    </div>

<Typography id="modal-modal-description" sx={{ mt: 2 }}>
  <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
    <div className="col-lg-6 form-group">
 

      <TextField
                      id="ProjectID"
                      label="Project ID "
                      //placeholder=""
                      name="ProjectID"
                      variant="outlined"
                      value={editedUser.ProjectId}
                      onChange={handleProjectIdChange}
                  />
    </div>
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={Number(editedUser.Active) === 1}  
            onChange={(e) =>
              setEditedUser((prev) => ({
                ...prev,
                Active: e.target.checked ? 1 : 0, 
              }))
            }
          />
        }
        label="Activate"
      />
    </FormGroup>
  </div>
</Typography>

</Typography>
                <Row>
                </Row>
            </DialogContent>
            <center>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                            <CustomButton
                                label={user ? 'Save' : 'Create'}
                                onClick={handleSave}
                                variant="contained"
                                size="medium"
                                height={40}
                                width="200px"
                                borderRadius="8px"
                                type="submit"
                                sx={{ flexGrow: 1 }}

                            />
                            <CustomButton
                                label="Cancel"
                                onClick={onClose}
                                variant="contained"
                                size="medium"
                                height={40}
                                width="200px"
                                borderRadius="8px"
                                type="submit"
                                sx={{ flexGrow: 1 }}
                                color="error"
                            />
                        </Stack>
                        <br />
                    </div>
                </Typography>
                <br></br>
            </center>
           
        </Dialog >
    );
};

const ViewDataPopup = ({ data, onClose }) => {
    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><u><b>Solar Project ID </b></u></DialogTitle>
            <DialogContent>
                <Row>
                    <Col xs={22} sm={10}>
                        <TextField label="Dealer Name" fullWidth value={data.DealerName} margin="normal" InputProps={{ readOnly: true, }} />
                    </Col>
                    <Col xs={4} sm={2}></Col>
                    <Col xs={22} sm={10}>
                        <TextField label="Project Id" fullWidth value={data.ProjectId} margin="normal" InputProps={{ readOnly: true, }} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={22} sm={10}>
                    <FormGroup>
  <FormControlLabel
    control={
      <Switch
        checked={Number(data.Active) === 1}  // Ensure Active is treated as number

      />
    }
    label="Active"
    InputProps={{ readOnly: true, }}
  />
</FormGroup>
                    </Col>
                    <Col xs={4} sm={2}></Col>
                    <Col xs={22} sm={10}>
                        
                    </Col>
                </Row>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '200px' }}>
                    <CustomButton
                        label="close"
                        onClick={onClose}
                        variant="contained"
                        fullWidth
                        width="400px"
                    />
                </Stack>
            </DialogActions>
            <br></br>
        </Dialog>

    );
};